"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_checkbox_1 = tslib_1.__importDefault(require("rc-checkbox"));
var config_provider_1 = require("../config-provider");
var context_1 = require("./context");
var InternalCheckbox = function (_a, ref) {
    var _b, _c;
    var customizePrefixCls = _a.prefixCls, className = _a.className, children = _a.children, _d = _a.indeterminate, indeterminate = _d === void 0 ? false : _d, style = _a.style, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, _e = _a.skipGroup, skipGroup = _e === void 0 ? false : _e, restProps = tslib_1.__rest(_a, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave", "skipGroup"]);
    var _f = React.useContext(config_provider_1.ConfigContext), getPrefixCls = _f.getPrefixCls, direction = _f.direction;
    var checkboxGroup = React.useContext(context_1.GroupContext);
    var prevValue = React.useRef(restProps.value);
    React.useEffect(function () {
        checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
    }, []);
    React.useEffect(function () {
        if (skipGroup) {
            return;
        }
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
        }
        return function () { return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value); };
    }, [restProps.value]);
    var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    var checkboxProps = tslib_1.__assign({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (restProps.onChange) {
                restProps.onChange.apply(restProps, tslib_1.__spreadArray([], tslib_1.__read(args), false));
            }
            if (checkboxGroup.toggleOption) {
                checkboxGroup.toggleOption({ label: children, value: restProps.value });
            }
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.indexOf(restProps.value) !== -1;
        checkboxProps.disabled = restProps.disabled || checkboxGroup.disabled;
    }
    var classString = (0, classnames_1.default)((_b = {},
        _b["".concat(prefixCls, "-wrapper")] = true,
        _b["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _b["".concat(prefixCls, "-wrapper-checked")] = checkboxProps.checked,
        _b["".concat(prefixCls, "-wrapper-disabled")] = checkboxProps.disabled,
        _b), className);
    var checkboxClass = (0, classnames_1.default)((_c = {},
        _c["".concat(prefixCls, "-indeterminate")] = indeterminate,
        _c));
    return (React.createElement("label", { className: classString, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        React.createElement(rc_checkbox_1.default, tslib_1.__assign({}, checkboxProps, { prefixCls: prefixCls, className: checkboxClass, 
            // @ts-ignore
            ref: ref })),
        children !== undefined && React.createElement("span", null, children)));
};
var AnqCheckbox = React.forwardRef(InternalCheckbox);
AnqCheckbox.displayName = 'AnqCheckbox';
exports.default = AnqCheckbox;
//# sourceMappingURL=Checkbox.js.map